import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { trackPaymentEvent, trackDonationIntentChange, trackFbpEvent, trackPurchase, trackConversion } from 'js/lib/analytics'
import { CHECKOUT_STEP_EVENT, CHECKOUT_SUBMIT_EVENT, CHECKOUT_ERROR_EVENT } from '../checkout/events'

registerFunctionalComponent('.js-c-payments-checkout-tracking', 'CheckoutTracking', component => {
  const root = component.element
  const { stage, payload, eventId } = root.dataset
  const purchase = JSON.parse(payload)

  if (stage === 'complete') {
    // Refreshes and browser history must not count the same checkout twice.
    const key = `payment-conversion:${purchase.transaction_id}`
    try {
      if (window.sessionStorage.getItem(key)) return
    } catch { /* Storage can be disabled; platform transaction/event IDs still deduplicate. */ }

    trackPurchase(purchase)
    if (purchase.donation) {
      trackConversion({ transaction_id: purchase.transaction_id, account_id: 'AW-363067286' })
      trackConversion({ transaction_id: purchase.transaction_id, account_id: 'AW-10806102563' })
      trackConversion({ transaction_id: purchase.transaction_id, account_id: 'AW-10806102563', conversion_segment: 'lULqCMKSq74DEKOU4KAo' })
    }
    try { window.sessionStorage.setItem(key, 'true') } catch { /* Optional duplicate suppression. */ }
    return
  }

  let lastStep = null
  const trackStep = stepName => {
    if (!stepName || stepName === lastStep) return
    lastStep = stepName
    trackPaymentEvent('payment_step_view', `checkout:${stepName}`, { ...purchase, step_name: stepName })
    if (stepName === 'payment' && purchase.donation) {
      trackDonationIntentChange({ pageName: purchase.content_name, value: purchase.donation_value, frequency: purchase.frequency })
    }
  }

  component.useHandler(() => on(CHECKOUT_STEP_EVENT, root, event => trackStep(event.detail?.stepName)))
  component.useHandler(() => on(CHECKOUT_SUBMIT_EVENT, root, () => {
    trackPaymentEvent('payment_submit', 'checkout:payment', purchase)
  }))
  component.useHandler(() => on(CHECKOUT_ERROR_EVENT, root, event => {
    trackPaymentEvent('payment_error', `checkout:${event.detail.stage}`, purchase)
  }))

  // Read server-rendered state after subscribing. This covers either mount order:
  // the form may already have emitted its initial event, or may mount afterwards.
  if (stage === 'checkout') {
    trackStep(root.querySelector('.js-c-payments-checkout-form__current-step')?.dataset.step)
  } else if (stage === 'error') {
    trackPaymentEvent('payment_error', 'checkout:error', purchase)
  } else {
    trackStep(stage)
  }
  if (stage !== 'selection' || !purchase.donation) return

  if (eventId) trackFbpEvent('ViewContent', { content_name: purchase.content_name }, { eventID: eventId })
  component.useHandler(() => on('change', root, event => {
    const input = event.target
    // Read only amount/frequency controls, never contact fields or gift personalization.
    if (!/\[(amount|custom_amount|frequency)\]$/.test(input.name || '')) return
    const form = input.closest('form')
    const custom = form.querySelector('.js-c-custom-amount-radio:checked')
    const amount = custom
      ? form.querySelector('.js-c-custom-amount-value:not(:disabled)')?.value
      : form.querySelector('input[name$="[amount]"]:checked:not(:disabled)')?.value || form.querySelector('input[name$="[amount]"]')?.value
    const frequency = form.querySelector('input[name$="[frequency]"]:checked')?.value || form.querySelector('input[name$="[frequency]"]')?.value
    const value = Number(amount)
    if (Number.isFinite(value) && value > 0) {
      trackDonationIntentChange({ pageName: purchase.content_name, value, frequency: frequency === 'monthly' ? 'monthly' : 'once' })
    }
  }))
})
